<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: 'SingleBar',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    xy: {
      type: String,
      default: 'x'
    },
    barWidth: {
      type: Number,
      default: 36
    },
    unit: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default() {
        return null
      }
    },
    full: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 1
    },
    fontSize: {
      type: Number,
      default: 12
    },
    interval: {
      type: String,
      default: 'auto'
    },
    showPercentage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    if (this.chartData) {
      this.initChart()
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      this.initChart()
    }
  },
  methods: {
    initChart() {
      var x = {
        type: 'category',
        axisTick: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: '#cbeeff',
            fontSize: this.fontSize
          },
          interval: this.interval
        },
        data: this.chartData.nameList
      }
      var y = {
        type: 'value',
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#414f5a',
            type: 'dashed'
          }
        },
        axisLabel: {
          textStyle: {
            color: '#cbeeff'
          },
          formatter: value => {
            return value + this.unit
          }
        }
      }
      var total = 0
      this.chartData.data.forEach(el => {
        total += parseInt(el)
      })
      var grid = {
        top: 20,
        bottom: 10,
        containLabel: true
      }
      if (this.full) {
        grid = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 10,
          containLabel: true
        }
      }
      var option = {
        grid: grid,
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        xAxis: this.xy == 'x' ? x : y,
        yAxis: this.xy == 'x' ? y : x,
        series: [
          {
            data: this.chartData.data,
            type: 'bar',
            barWidth: this.barWidth,
            itemStyle: {
              normal: {
                // 每根柱子颜色设置
                color: function(params) {
                  let colorList = [
                    '#ff664d',
                    '#ff7d43',
                    '#ffa348',
                    '#ffcc5a',
                    '#f2ea5f',
                    '#b7d85b',
                    '#7ba355',
                    '#8ccd9c',
                    '#7ceaed',
                    '#5acbe5'
                  ]
                  return colorList[params.dataIndex]
                },
                opacity: this.opacity,
                label: {
                  show: true,
                  position: this.xy == 'x' ? 'top' : 'right',
                  formatter: params => {
                    if (this.showPercentage) {
                      return Math.round((params.value / total) * 100) + '%'
                    }
                  }
                }
              }
            }
          }
        ]
      }

      this.chart = this.$echarts.init(document.getElementById(this.id))
      this.chart.setOption(option)
    }
  }
}
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
